<script setup lang="ts">
import MultiStepForm from '~/components/MultiStepForm/index.vue'

const { slug } = useRoute().params as { slug: string }

interface JobData {
  title: string
  location: string
  description: string
  tasks: string[]
  profile: string[]
}

const jobs: Record<string, JobData> = {}

const job = computed(() => jobs[slug])

definePageMeta({
  title: computed(() => job.value?.title || 'Stellenanzeige'),
})
</script>

<template>
  <main v-if="job" class="mx-auto min-h-screen max-w-[1100px] px-6 py-20">
    <header class="mb-8">
      <h1 class="text-[40px] font-semibold leading-[1.1] text-black md:text-[56px]">{{ job.title }}</h1>
      <p class="mt-2 text-text-muted">{{ job.location }}</p>
    </header>

    <section class="mb-8">
      <h2 class="mb-4 text-[26px] font-semibold leading-[1.2] md:text-[35px]">Über uns</h2>
      <p class="text-base leading-[1.7] text-black">{{ job.description }}</p>
    </section>

    <section class="mb-8">
      <h2 class="mb-4 text-[26px] font-semibold leading-[1.2] md:text-[35px]">Deine Aufgaben</h2>
      <ul class="list-disc pl-5 text-base leading-[1.7] text-black">
        <li v-for="item in job.tasks" :key="item">{{ item }}</li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="mb-4 text-[26px] font-semibold leading-[1.2] md:text-[35px]">Dein Profil</h2>
      <ul class="list-disc pl-5 text-base leading-[1.7] text-black">
        <li v-for="item in job.profile" :key="item">{{ item }}</li>
      </ul>
    </section>

    <MultiStepForm />
  </main>
  <main v-else class="mx-auto min-h-screen max-w-[1100px] px-6 py-20">
    <h1 class="text-[40px] font-semibold leading-[1.1] text-black md:text-[56px]">Stelle nicht gefunden</h1>
    <p class="mt-2 text-text-muted">Diese Stellenanzeige existiert nicht.</p>
  </main>
</template>
